import { CountryCode } from 'libphonenumber-js/types';
import { getExampleNumber } from 'libphonenumber-js/mobile';
import examples from 'libphonenumber-js/examples.mobile.json';

export class Country {
  name: string;
  ISO2: CountryCode;
  ISD: string;
  prefixedISD: string;
  continent: string;
  exampleNumber: string;
  exampleNSN: string;
  exampleFormat: string;
  maxLength: number;

  constructor(countryData: any) {
    this.name = countryData[0];
    this.ISO2 = <CountryCode>countryData[1];
    this.ISD = countryData[2];
    this.prefixedISD = '+' + countryData[2];
    // this.continent = countryData[3];
    this.exampleNumber =
      getExampleNumber(
        countryData[1].toUpperCase(),
        examples
      ).formatInternational() || null;

    const regex = new RegExp(
      `\\+\\s*${this.ISD.split(' ').join('').split('').join('\\s*')}\\s*`
    );

    this.exampleNSN =
      this.exampleNumber.replace(regex, '').replace('+', '').trim() || null;
    this.exampleFormat = `+${this.ISD} ${this.exampleNSN.replace(/\d/g, 'x')}`;
    this.maxLength = this.exampleNSN.split(' ').join('').length;
  }
}
